import { React, useContext, useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import GoBack from "../../components/goBack";
import { Navigate, useNavigate } from "react-router-dom";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { baseURL } from "../../services/api";
import AuthContext from "../../components/shared/AuthContext";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { DataGrid, enUS, frFR, GridToolbar } from "@mui/x-data-grid";
import { LinearProgress } from "@mui/material";
import moment from "moment/moment";
import useAuthHelper from "../../helpers/AuthHelper";

const ListMembers = () => {
  const [t, i18n] = useTranslation();
  const { onlyAdmins } = useAuthHelper();
  const { user } = useContext(AuthContext);

  const [teamMembers, setTeamMembers] = useState([]);
  const [loadingData, setLoadingData] = useState(false);

  useEffect(() => {
    onlyAdmins(user);
    getTeamMembers();
  }, []);

  const getTeamMembers = async () => {
    setLoadingData(true);
    try {
      const response = await jwtInterceoptor.get(`/data/team/list/${user.id}`);
      if (response.status === 200 && response.data && response.data.data) {
        setTeamMembers(response.data.data);
      } else {
        setTeamMembers([]);
      }
    } catch (error) {
      console.error("Error fetching team members:", error);
      toast.error(t("Failed to load team members"));
    }
    setLoadingData(false);
  };

  const navigate = useNavigate();

  const updateTeamMembre = (member) => {
    navigate(`/team/modify/${member.id}`);
  };

  const deleteTeamMember = (member) => {
    Swal.fire({
      title: t("Are you sure?"),
      text: t("You won't be able to revert this!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: t("Yes, delete it!"),
      cancelButtonText: t("Cancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await jwtInterceoptor.delete(
            `/data/team/member/${member.id}`
          );
          if (response.status === 200 && response.data.status) {
            setTeamMembers((prevMembers) =>
              prevMembers.filter((el) => el.id !== member.id)
            );
            Swal.fire(
              t("Deleted!"),
              t("Your record has been deleted."),
              "success"
            );
          } else {
            throw new Error();
          }
        } catch (error) {
          Swal.fire({
            icon: "warning",
            title: "",
            text: t("Something went wrong!, try again"),
          });
        }
      }
    });
  };

  const columns = [
    {
      flex: 1,
      field: "Nom complet",
      headerName: t("Nom complet"),
      valueGetter: (params) => params.row.name + " " + params.row.nick_name,
    },
    {
      flex: 1,
      field: "Email",
      headerName: t("Email"),
      valueGetter: (params) => params.row.email,
    },
    {
      flex: 1,
      field: "Organisation associée",
      headerName: t("Organisation associée"),
      valueGetter: (params) => params.row.orgsLinkedTo,
    },
    {
      flex: 1,
      field: "Permission",
      headerName: t("Permission"),
      valueGetter: (params) => params.row.role?.role_name || "Unknown",
    },
    {
      flex: 1,
      field: "Date de création",
      headerName: t("Date de création"),
      valueGetter: (params) =>
        `${moment(params.row.created_at).format("DD/MM/YYYY") || ""}`,
    },
    {
      field: "Actions",
      headerName: t("Actions"),
      width: 180,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (params) => (
        <div className="btn-list">
          <button
            className="btn  btn-sm btn-primary"
            onClick={() => updateTeamMembre(params.row)}
            id="bEdit"
            type="button"
          >
            <span className="fe fe-edit"> </span>
          </button>
          <button
            onClick={() => deleteTeamMember(params.row)}
            id="bDel"
            type="button"
            className="btn  btn-sm btn-danger"
          >
            <span className="fe fe-trash-2"> </span>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <ToastContainer />
      <div className="row" style={{ zIndex: 1 }}>
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header container-fluid row">
              <div className="col-md-9 col-sm-12 card-title">
                {t("Liste des membres d'équipe")}
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div style={{ height: 600, width: "100%" }}>
                  <DataGrid
                    rows={teamMembers}
                    columns={columns}
                    pagination={false}
                    localeText={
                      i18n.language === "fr"
                        ? frFR.components.MuiDataGrid.defaultProps.localeText
                        : enUS.components.MuiDataGrid.defaultProps.localeText
                    }
                    slotProps={{
                      toolbar: {
                        printOptions: { disableToolbarButton: true },
                        csvOptions: { disableToolbarButton: true },
                      },
                    }}
                    slots={{
                      loadingOverlay: LinearProgress,
                      toolbar: GridToolbar,
                    }}
                    loading={loadingData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListMembers;
